/**
 * VueLayers
 * Web map Vue components with the power of OpenLayers
 *
 * @package vuelayers
 * @author Vladimir Vershinin <ghettovoice@gmail.com>
 * @version 0.11.37
 * @license MIT
 * @copyright (c) 2017-2021, Vladimir Vershinin <ghettovoice@gmail.com>
 */
import PluggableMap from 'ol/PluggableMap';
import Vue from 'vue';

function getMapId(map) {
  if (map instanceof Vue) {
    return map.id;
  } else if (map instanceof PluggableMap) {
    return map.get('id');
  }

  throw new Error('Illegal map argument');
}
function setMapId(map, mapId) {
  if (map instanceof Vue) {
    map.id = mapId;
    return map;
  } else if (map instanceof PluggableMap) {
    map.set('id', mapId);
    return map;
  }

  throw new Error('Illegal map argument');
}
function getMapDataProjection(map) {
  if (map instanceof Vue) {
    return map.dataProjection;
  } else if (map instanceof PluggableMap) {
    return map.get('dataProjection');
  }

  throw new Error('Illegal map argument');
}
function setMapDataProjection(map, dataProjection) {
  if (map instanceof Vue) {
    map.dataProjection = dataProjection;
    return map;
  } else if (map instanceof PluggableMap) {
    map.set('dataProjection', dataProjection);
    return map;
  }

  throw new Error('Illegal map argument');
}

export { getMapId, setMapId, getMapDataProjection, setMapDataProjection };
